import {finalAddressSelector} from '@stencil/hotels-details-reducer/src/selectors';
import {defaultTheme} from '@stencil/build-theme';
import React from 'react';
import {useSelector} from 'react-redux';
import styled from 'styled-components';
import LocationInfoIcon from '../../../../../stories/Icons/LocationInfoIcon';
import {PrimaryLink} from '../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';

import LocationPin from '../../../../../stories/Icons/LocationIcon';

// SELECTOR FNS
// ICONS
// CONFIG
const HotelAddressTextSpan = styled.span(
  props => `
  color: ${props.theme.colors.downriver.medium};
  display: flex;
  align-items: center;
`,
);

const HotelAddressStyled = styled.address(
  props => `
  font-style: inherit;
  padding: 0 ${props.theme.spacing.small};
`,
);

function HotelAddressText() {
  const finalAddressText = useSelector(finalAddressSelector);

  /** this piece of code is to prevent duplication of text
   * but if this is used to conditionally show hotelArea, hotelCountry, hotelPincode
   * then the schema.org attributes will be missed. Hence allowing duplication for now
   *
   * note: duplication was always there in old dweb implementation.
   */
  // const hotelAddressTextDoesNotIncludeHotelArea =
  //   hotelAddressText && !hotelAddressText.include(hotelArea);
  // const hotelAddressTextDoesNotIncludeHotelCountry =
  //   hotelAddressText && !hotelAddressText.include(hotelCountry);
  // const hotelAddressTextDoesNotIncludePinCode =
  //   hotelAddressText && !hotelAddressText.include(hotelAreaPincode);
  if (!finalAddressText) {
    return null;
  }

  return (
    <HotelAddressTextSpan>
      {/* <LocationPin width="18px" height="18px" fill={defaultTheme.colors.downriver.medium} /> */}
      <LocationInfoIcon />
      <HotelAddressStyled itemScope itemProp="address" itemType="http://schema.org/PostalAddress">
        {finalAddressText && (
          <span itemProp="streetAddress">
            {finalAddressText} <PrimaryLink>View on Map</PrimaryLink>
          </span>
        )}
      </HotelAddressStyled>
    </HotelAddressTextSpan>
  );
}

export default HotelAddressText;
